import {GroupAWDStatus} from 'ApplicationEntry/models/AWDStatus/GroupAWDStatus';
import {NewYorkAWDStatus} from 'ApplicationEntry/models/AWDStatus/NewYorkAWDStatus';
import {OrdinaryAWDStatus} from 'ApplicationEntry/models/AWDStatus/OrdinaryAWDStatus';

export type AWDStatus = OrdinaryAWDStatus | GroupAWDStatus | NewYorkAWDStatus;

type ExhaustiveAWDStatusOptionsByType<TReturn> = {
  Group: (group: GroupAWDStatus) => TReturn;
  Ordinary: (ordinary: OrdinaryAWDStatus) => TReturn;
  NewYork: (newYork: NewYorkAWDStatus) => TReturn;
};

type PartialAWDStatusOptionsByType<TReturn> = {
  Group?: (group: GroupAWDStatus) => TReturn;
  Ordinary?: (ordinary: OrdinaryAWDStatus) => TReturn;
  NewYork?: (newYork: NewYorkAWDStatus) => TReturn;
  _: (app: AWDStatus) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: AWDStatusByTypeOptions<TReturn>
): options is ExhaustiveAWDStatusOptionsByType<TReturn> => !!options.Group && !!options.NewYork && !!options.Ordinary;

type AWDStatusByTypeOptions<TReturn> =
  | PartialAWDStatusOptionsByType<TReturn>
  | ExhaustiveAWDStatusOptionsByType<TReturn>;

export const matchAWDStatusByType = <TReturn>(options: AWDStatusByTypeOptions<TReturn>) => (
  app: AWDStatus
): TReturn => {
  switch (app.key) {
    case 'InvalidGroupAWDStatus':
    case 'ValidGroupAWDStatus':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkAWDStatus':
    case 'ValidNewYorkAWDStatus':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
    case 'InvalidOrdinaryAWDStatus':
    case 'ValidOrdinaryAWDStatus':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
  }
};

export const isValidAWDStatus = (awdStatus: AWDStatus) =>
  awdStatus.key === 'ValidGroupAWDStatus' ||
  awdStatus.key === 'ValidNewYorkAWDStatus' ||
  awdStatus.key === 'ValidOrdinaryAWDStatus';

